export default __webpack_public_path__ + "static/media/flower-2 2.df25d79b.png";